const item = Object.freeze({
  Submitted: 1,
  Cancelled: 2,
  OnTransferRoute: 3,
  NoApproved: 4,
  Approved: 5,
  Transferred: 6,
});
export default item;
